import { IPaymentMethodEntry } from "./types";

/** The payment_methods entries qrokoro acts on; other entries belong to SOK/KPOS flows. */
export const PAYMENT_METHOD = {
	LINKPAY: "linkpay",
	ADYEN: "adyen",
} as const;

/**
 * A method is offered only when the venue's list says so: present AND qr_enabled. A
 * missing entry - or a venue with no list at all - reads as off, so a venue offers
 * nothing the backend has not curated for it.
 */
export const isPaymentMethodEnabled = (
	methods: IPaymentMethodEntry[] | undefined,
	method: string
): boolean => (methods ?? []).some((entry) => entry.method === method && entry.qr_enabled);
